// extracted by mini-css-extract-plugin
export default {"spaceCardContainer":"documentation-card_spaceCardContainer__Yi2VK"};